export default {
	currentStep: 4,
	id: '1640847583880',
	selectedProductIndex: 0,
	// isSubmited: false,
	policyHolder: {
		details: {
			salutationId: null,
			surname: 'hien',
			forename: 'đỗ',
			dateOfBirth: '2003-12-12',
			genderId: 1,
			residenceCountryId: 2,
			occupationId: 1,
			nationalityCountryId: 2,
			isTaxEnable: false,
			taxIdentificationNumber: '',
		},
		contactDetails: {
			lineNumberCountryCodeId: 2,
			landlineNumber: '',
			countryCodeMobileId: 2,
			mobileNumber: '+841646089580',
			emailAddress: 'dodanghien.23693@gmail.com',
		},
		additionalDetails: {
			isSportOrPastime: true,
			pastimeId: 1,
			otherPastimes: '',
			refusedCoverOrAcceptedOnSpecialTerms: false,
			refusedCoverOrAcceptedOnSpecialTermsDate: null,
			refusedCoverOrAcceptedOnSpecialTermsDetails: '',
			insuranceProvider: null,
			bmi: { unit: 0, centimeters: '100', kilograms: '100' },
			countryResidenceAddress: {
				address1: '',
				address2: '',
				address3: '',
				state: '',
				city: '',
				zipCode: '',
				countryId: 2,
			},
			homeCountryAddress: {
				address1: '',
				address2: '',
				address3: '',
				state: '',
				city: '',
				zipCode: '',
				countryId: 2,
			},
			physicianDetails: {
				salutationId: 1,
				forename: '',
				surname: '',
				practiceName: 'hien',
				dateLastVisited: '2021-12-22',
				email: '',
				countryCodeId: null,
				telephoneNumber: '',
				address: {
					address1: 'hoai duc',
					address2: '',
					address3: '',
					state: 'hanoi',
					city: 'ha noi',
					countryId: 3,
					zipCode: '10000',
				},
				haveExistingHealthInsurance: false,
				insuranceProvider: null,
			},
			documents: [],
			fileUploaded: [],
		},
	},
	familyMembers: [
		{
			id: '1640248965239',
			details: {
				salutationId: 1,
				forename: 'hien1',
				surname: 'do1',
				dateOfBirth: '2010-05-05',
				genderId: 2,
				occupationId: 2,
				nationalityCountryId: 2,
				relationshipId: 3,
			},
			additionalDetails: {
				isSportOrPastime: true,
				pastimeId: 2,
				otherPastimes: 'test 1 ',
				refusedCoverOrAcceptedOnSpecialTerms: false,
				refusedCoverOrAcceptedOnSpecialTermsDate: null,
				refusedCoverOrAcceptedOnSpecialTermsDetails: '',
				bmi: {
					unit: 0,
					centimeters: '170',
					kilograms: '70',
				},
				physicianDetails: {
					physicianSamePolicyHolder: true,
					salutationId: 1,
					forename: 'hien',
					surname: 'do',
					practicename: '',
					dateLastVisited: '2021-11-11',
					email: 'ha.noi@gmail.com',
					countryCodeId: 2,
					telephoneNumber: '+84876611122',
					address: {
						address1: 'ha noi, ha noi,ha noi, ha noi,ha noi, hà nội',
						address2: 'ha noi, ha noi, ha noi',
						address3: '21321',
						state: 'Hà Nội',
						city: 'Hoài Đức',
						countryId: 2,
						zipCode: '100000',
					},
					healthInsuraceSamePolicyHolder: false,
					haveExistingHealthInsurance: false,
					insuranceProvider: {},
					practiceName: 'test',
				},
				documents: [
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Passport',
						fileName: 'Sihouette.ava.1.2.3.jpg',
						willUploadFileName: 'Sihouette.ava.1.2.3.jpg',
					},
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Proof of address',
						fileName: 'twitter-login-background.png',
						willUploadFileName: 'twitter-login-background.png',
					},
				],
			},
			underwritingQuestions: [
				{
					questionId: 57,
					questionNumber: 2,
					answer: {
						nameOfMedicalCondition: '12',
						dateStarted: '2021-11-13',
						dateEnded: '2021-11-23',
						currentMedicationName: '123123',
						hasHospitalRelationToCondition: false,
						currentConditionId: 1,
					},
					isAnswer: true,
				},
			],
		},
		{
			id: '1640248965238',
			details: {
				salutationId: 1,
				forename: 'hien2',
				surname: 'do2',
				dateOfBirth: '2010-05-05',
				genderId: 2,
				occupationId: 3,
				nationalityCountryId: 2,
				relationshipId: 3,
			},
			additionalDetails: {
				isSportOrPastime: true,
				pastimeId: 2,
				otherPastimes: 'test 1 ',
				refusedCoverOrAcceptedOnSpecialTerms: false,
				refusedCoverOrAcceptedOnSpecialTermsDate: null,
				refusedCoverOrAcceptedOnSpecialTermsDetails: '',
				bmi: {
					unit: 0,
					centimeters: '170',
					kilograms: '70',
				},
				physicianDetails: {
					physicianSamePolicyHolder: true,
					salutationId: 1,
					forename: 'hien',
					surname: 'do',
					practicename: '',
					dateLastVisited: '2021-11-11',
					email: 'ha.noi@gmail.com',
					countryCodeId: 2,
					telephoneNumber: '+84876611122',
					address: {
						address1: 'ha noi, ha noi,ha noi, ha noi,ha noi, hà nội',
						address2: 'ha noi, ha noi, ha noi',
						address3: '21321',
						state: 'Hà Nội',
						city: 'Hoài Đức',
						countryId: 2,
						zipCode: '100000',
					},
					healthInsuraceSamePolicyHolder: false,
					haveExistingHealthInsurance: false,
					insuranceProvider: {},
					practiceName: 'test',
				},
				documents: [
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Passport',
						fileName: 'Sihouette.ava.1.2.3.jpg',
						willUploadFileName: 'Sihouette.ava.1.2.3.jpg',
					},
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Proof of address',
						fileName: 'twitter-login-background.png',
						willUploadFileName: 'twitter-login-background.png',
					},
				],
			},
			underwritingQuestions: [
				{
					questionId: 57,
					questionNumber: 2,
					answer: {
						nameOfMedicalCondition: '12',
						dateStarted: '2021-11-13',
						dateEnded: '2021-11-23',
						currentMedicationName: '123123',
						hasHospitalRelationToCondition: false,
						currentConditionId: 1,
					},
					isAnswer: true,
				},
			],
		},
		{
			id: '1640248965237',
			details: {
				salutationId: 1,
				forename: 'hien3',
				surname: 'do3',
				dateOfBirth: '2010-05-05',
				genderId: 2,
				occupationId: 4,
				nationalityCountryId: 2,
				relationshipId: 3,
			},
			additionalDetails: {
				isSportOrPastime: true,
				pastimeId: 2,
				otherPastimes: 'test 1 ',
				refusedCoverOrAcceptedOnSpecialTerms: false,
				refusedCoverOrAcceptedOnSpecialTermsDate: null,
				refusedCoverOrAcceptedOnSpecialTermsDetails: '',
				bmi: {
					unit: 0,
					centimeters: '170',
					kilograms: '70',
				},
				physicianDetails: {
					physicianSamePolicyHolder: true,
					salutationId: 1,
					forename: 'hien',
					surname: 'do',
					practicename: '',
					dateLastVisited: '2021-11-11',
					email: 'ha.noi@gmail.com',
					countryCodeId: 2,
					telephoneNumber: '+84876611122',
					address: {
						address1: 'ha noi, ha noi,ha noi, ha noi,ha noi, hà nội',
						address2: 'ha noi, ha noi, ha noi',
						address3: '21321',
						state: 'Hà Nội',
						city: 'Hoài Đức',
						countryId: 2,
						zipCode: '100000',
					},
					healthInsuraceSamePolicyHolder: false,
					haveExistingHealthInsurance: false,
					insuranceProvider: {},
					practiceName: 'test',
				},
				documents: [
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Passport',
						fileName: 'Sihouette.ava.1.2.3.jpg',
						willUploadFileName: 'Sihouette.ava.1.2.3.jpg',
					},
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Proof of address',
						fileName: 'twitter-login-background.png',
						willUploadFileName: 'twitter-login-background.png',
					},
				],
			},
			underwritingQuestions: [
				{
					questionId: 57,
					questionNumber: 2,
					answer: {
						nameOfMedicalCondition: '12',
						dateStarted: '2021-11-13',
						dateEnded: '2021-11-23',
						currentMedicationName: '123123',
						hasHospitalRelationToCondition: false,
						currentConditionId: 1,
					},
					isAnswer: true,
				},
			],
		},
		{
			id: '1640348965237',
			details: {
				salutationId: 1,
				forename: 'hien3',
				surname: 'do3',
				dateOfBirth: '2010-05-05',
				genderId: 2,
				occupationId: 4,
				nationalityCountryId: 2,
				relationshipId: 3,
			},
			additionalDetails: {
				isSportOrPastime: true,
				pastimeId: 2,
				otherPastimes: 'test 1 ',
				refusedCoverOrAcceptedOnSpecialTerms: false,
				refusedCoverOrAcceptedOnSpecialTermsDate: null,
				refusedCoverOrAcceptedOnSpecialTermsDetails: '',
				bmi: {
					unit: 0,
					centimeters: '170',
					kilograms: '70',
				},
				physicianDetails: {
					physicianSamePolicyHolder: true,
					salutationId: 1,
					forename: 'hien',
					surname: 'do',
					practicename: '',
					dateLastVisited: '2021-11-11',
					email: 'ha.noi@gmail.com',
					countryCodeId: 2,
					telephoneNumber: '+84876611122',
					address: {
						address1: 'ha noi, ha noi,ha noi, ha noi,ha noi, hà nội',
						address2: 'ha noi, ha noi, ha noi',
						address3: '21321',
						state: 'Hà Nội',
						city: 'Hoài Đức',
						countryId: 2,
						zipCode: '100000',
					},
					healthInsuraceSamePolicyHolder: false,
					haveExistingHealthInsurance: false,
					insuranceProvider: {},
					practiceName: 'test',
				},
				documents: [
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Passport',
						fileName: 'Sihouette.ava.1.2.3.jpg',
						willUploadFileName: 'Sihouette.ava.1.2.3.jpg',
					},
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Proof of address',
						fileName: 'twitter-login-background.png',
						willUploadFileName: 'twitter-login-background.png',
					},
				],
			},
			underwritingQuestions: [
				{
					questionId: 57,
					questionNumber: 2,
					answer: {
						nameOfMedicalCondition: '12',
						dateStarted: '2021-11-13',
						dateEnded: '2021-11-23',
						currentMedicationName: '123123',
						hasHospitalRelationToCondition: false,
						currentConditionId: 1,
					},
					isAnswer: true,
				},
			],
		},
		{
			id: '1460348965237',
			details: {
				salutationId: 1,
				forename: 'hien3',
				surname: 'do3',
				dateOfBirth: '2010-05-05',
				genderId: 2,
				occupationId: 4,
				nationalityCountryId: 2,
				relationshipId: 3,
			},
			additionalDetails: {
				isSportOrPastime: true,
				pastimeId: 2,
				otherPastimes: 'test 1 ',
				refusedCoverOrAcceptedOnSpecialTerms: false,
				refusedCoverOrAcceptedOnSpecialTermsDate: null,
				refusedCoverOrAcceptedOnSpecialTermsDetails: '',
				bmi: {
					unit: 0,
					centimeters: '170',
					kilograms: '70',
				},
				physicianDetails: {
					physicianSamePolicyHolder: true,
					salutationId: 1,
					forename: 'hien',
					surname: 'do',
					practicename: '',
					dateLastVisited: '2021-11-11',
					email: 'ha.noi@gmail.com',
					countryCodeId: 2,
					telephoneNumber: '+84876611122',
					address: {
						address1: 'ha noi, ha noi,ha noi, ha noi,ha noi, hà nội',
						address2: 'ha noi, ha noi, ha noi',
						address3: '21321',
						state: 'Hà Nội',
						city: 'Hoài Đức',
						countryId: 2,
						zipCode: '100000',
					},
					healthInsuraceSamePolicyHolder: false,
					haveExistingHealthInsurance: false,
					insuranceProvider: {},
					practiceName: 'test',
				},
				documents: [
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Passport',
						fileName: 'Sihouette.ava.1.2.3.jpg',
						willUploadFileName: 'Sihouette.ava.1.2.3.jpg',
					},
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Proof of address',
						fileName: 'twitter-login-background.png',
						willUploadFileName: 'twitter-login-background.png',
					},
				],
			},
			underwritingQuestions: [
				{
					questionId: 57,
					questionNumber: 2,
					answer: {
						nameOfMedicalCondition: '12',
						dateStarted: '2021-11-13',
						dateEnded: '2021-11-23',
						currentMedicationName: '123123',
						hasHospitalRelationToCondition: false,
						currentConditionId: 1,
					},
					isAnswer: true,
				},
			],
		},
		{
			id: '1640348961137',
			details: {
				salutationId: 1,
				forename: 'hien3',
				surname: 'do3',
				dateOfBirth: '2010-05-05',
				genderId: 2,
				occupationId: 4,
				nationalityCountryId: 2,
				relationshipId: 3,
			},
			additionalDetails: {
				isSportOrPastime: true,
				pastimeId: 2,
				otherPastimes: 'test 1 ',
				refusedCoverOrAcceptedOnSpecialTerms: false,
				refusedCoverOrAcceptedOnSpecialTermsDate: null,
				refusedCoverOrAcceptedOnSpecialTermsDetails: '',
				bmi: {
					unit: 0,
					centimeters: '170',
					kilograms: '70',
				},
				physicianDetails: {
					physicianSamePolicyHolder: true,
					salutationId: 1,
					forename: 'hien',
					surname: 'do',
					practicename: '',
					dateLastVisited: '2021-11-11',
					email: 'ha.noi@gmail.com',
					countryCodeId: 2,
					telephoneNumber: '+84876611122',
					address: {
						address1: 'ha noi, ha noi,ha noi, ha noi,ha noi, hà nội',
						address2: 'ha noi, ha noi, ha noi',
						address3: '21321',
						state: 'Hà Nội',
						city: 'Hoài Đức',
						countryId: 2,
						zipCode: '100000',
					},
					healthInsuraceSamePolicyHolder: false,
					haveExistingHealthInsurance: false,
					insuranceProvider: {},
					practiceName: 'test',
				},
				documents: [
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Passport',
						fileName: 'Sihouette.ava.1.2.3.jpg',
						willUploadFileName: 'Sihouette.ava.1.2.3.jpg',
					},
					{
						postfix: 'FamilyMember_1640248965239',
						name: 'Proof of address',
						fileName: 'twitter-login-background.png',
						willUploadFileName: 'twitter-login-background.png',
					},
				],
			},
			underwritingQuestions: [
				{
					questionId: 57,
					questionNumber: 2,
					answer: {
						nameOfMedicalCondition: '12',
						dateStarted: '2021-11-13',
						dateEnded: '2021-11-23',
						currentMedicationName: '123123',
						hasHospitalRelationToCondition: false,
						currentConditionId: 1,
					},
					isAnswer: true,
				},
			],
		},
	],
	product: {
		productId: 2,
		areaId: 5,
		levelOfCoverId: 7,
		frequencyId: 5,
		selectedExcessId: 10,
		coInsuranceSelectedId: 6,
		additionalBenefitSelectedListId: [],
		taxType: null,
		taxPercent: 0,
		taxValue: 0,
	},
	underwritingTypeId: 1,
	underwritingQuestions: [
		{
			questionId: 56,
			questionNumber: 1,
			answer: {
				nameOfMedicalCondition: '',
				dateStarted: null,
				dateEnded: null,
				currentMedicationName: '',
				hasHospitalRelationToCondition: null,
				currentConditionId: '',
			},
			isAnswer: false,
		},
		{
			questionId: 57,
			questionNumber: 2,
			answer: {
				nameOfMedicalCondition: '',
				dateStarted: null,
				dateEnded: null,
				currentMedicationName: '',
				hasHospitalRelationToCondition: null,
				currentConditionId: '',
			},
			isAnswer: false,
		},
		{ questionId: 58, questionNumber: 3, answer: null },
		{ questionId: 59, questionNumber: 4, answer: null },
		{ questionId: 60, questionNumber: 5, answer: null },
		{ questionId: 61, questionNumber: 6, answer: null },
		{ questionId: 62, questionNumber: 6.1, answer: null },
		{ questionId: 63, questionNumber: 6.2, answer: null },
		{ questionId: 64, questionNumber: 6.3, answer: null },
		{ questionId: 65, questionNumber: 6.4, answer: null },
		{ questionId: 66, questionNumber: 6.5, answer: null },
		{ questionId: 67, questionNumber: 6.6, answer: null },
		{ questionId: 68, questionNumber: 6.7, answer: null },
		{ questionId: 69, questionNumber: 6.8, answer: null },
		{ questionId: 70, questionNumber: 6.9, answer: null },
		{ questionId: 71, questionNumber: 6.1, answer: null },
		{ questionId: 72, questionNumber: 6.11, answer: null },
		{ questionId: 73, questionNumber: 6.12, answer: null },
		{ questionId: 74, questionNumber: 6.13, answer: null },
		{ questionId: 75, questionNumber: 6.14, answer: null },
		{ questionId: 76, questionNumber: 6.15, answer: null },
		{ questionId: 77, questionNumber: 6.16, answer: null },
		{ questionId: 78, questionNumber: 6.17, answer: null },
		{ questionId: 79, questionNumber: 6.18, answer: null },
		{ questionId: 80, questionNumber: 6.19, answer: null },
		{ questionId: 81, questionNumber: 6.2, answer: null },
		{ questionId: 82, questionNumber: 6.21, answer: null },
		{ questionId: 83, questionNumber: 6.22, answer: null },
		{ questionId: 84, questionNumber: 6.23, answer: null },
		{ questionId: 85, questionNumber: 6.24, answer: null },
		{ questionId: 86, questionNumber: 6.25, answer: null },
		{ questionId: 87, questionNumber: 6.26, answer: null },
		{ questionId: 88, questionNumber: 6.27, answer: null },
		{ questionId: 89, questionNumber: 6.28, answer: null },
		{ questionId: 90, questionNumber: 6.29, answer: null },
		{ questionId: 91, questionNumber: 6.3, answer: null },
		{ questionId: 92, questionNumber: 6.31, answer: null },
		{ questionId: 93, questionNumber: 6.32, answer: null },
		{ questionId: 94, questionNumber: 6.33, answer: null },
		{ questionId: 95, questionNumber: 6.34, answer: null },
		{ questionId: 96, questionNumber: 6.35, answer: null },
		{ questionId: 97, questionNumber: 6.36, answer: null },
		{ questionId: 98, questionNumber: 6.37, answer: null },
		{ questionId: 99, questionNumber: 6.38, answer: null },
		{ questionId: 100, questionNumber: 6.39, answer: null },
		{ questionId: 101, questionNumber: 6.4, answer: null },
		{ questionId: 102, questionNumber: 6.41, answer: null },
		{ questionId: 103, questionNumber: 6.42, answer: null },
		{ questionId: 104, questionNumber: 6.43, answer: null },
		{ questionId: 105, questionNumber: 6.44, answer: null },
		{ questionId: 106, questionNumber: 6.45, answer: null },
		{ questionId: 107, questionNumber: 6.46, answer: null },
		{ questionId: 108, questionNumber: 6.47, answer: null },
		{ questionId: 109, questionNumber: 6.48, answer: null },
		{ questionId: 110, questionNumber: 6.49, answer: null },
	],
	policyDetails: { policyStartDate: '2022-01-24', policyHolderInsured: true, currencyId: 2 },
}
